module.exports = __webpack_public_path__ + "static/img/rubiks-cubes.ec7e5dd9.png";